import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Flex,
  Link,
  Text,
  IconButton,
  Box,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { TEXTS } from "../constants/texts";

export interface TicketModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface InlineTextProps {
  texts: string[];
  mt?: number;
  links?: { [key: number]: string };
  target?: string;
}

const InlineText: React.FC<InlineTextProps> = ({
  texts,
  mt = 4,
  links,
  target,
}) => (
  <Flex mt={mt}>
    {texts.map((text, index) => (
      <React.Fragment key={index}>
        {links && links[index] ? (
          <Link
            href={links[index]}
            color="blue.500"
            textDecoration="underline"
            target={target}
            fontSize={{
              base: "11px",
              md: "md",
              lg: "md",
              xl: "md",
              "2xl": "md",
            }}
          >
            {text}
          </Link>
        ) : (
          <Text
            fontSize={{
              base: "11px",
              md: "md",
              lg: "md",
              xl: "md",
              "2xl": "md",
            }}
          >
            {text}
          </Text>
        )}
      </React.Fragment>
    ))}
  </Flex>
);

const SectionHeader: React.FC<{ text: string }> = ({ text }) => (
  <ModalHeader
    color="black"
    mt={2}
    px={0}
    fontSize={{ base: "xs", md: "lg", lg: "xl" }}
  >
    {text}
  </ModalHeader>
);

const TicketModal: React.FC<TicketModalProps> = ({ isOpen, onClose }) => {
  const { webMember } = TEXTS.Ticket;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      isCentered
      blockScrollOnMount={false}
    >
      <ModalOverlay />
      <ModalContent bg="rgb(241, 236, 222)">
        <Box position="relative">
          <ModalHeader
            color="black"
            fontSize={{ base: "xs", md: "lg", lg: "xl" }}
          >
            {webMember[0]}
          </ModalHeader>
          <IconButton
            aria-label="Close modal"
            icon={<CloseIcon />}
            position="absolute"
            right={2}
            top={2}
            onClick={onClose}
            variant="ghost"
            color="gray.500"
            _hover={{ bg: "gray.100" }}
            size="sm"
            borderRadius="full"
          />
        </Box>
        <ModalBody color="black" pb={6} pt={0}>
          <Text fontSize={{ base: "11px", md: "md", lg: "md" }}>
            {webMember[1]}
          </Text>
          <InlineText
            target="_blank"
            texts={[webMember[2], webMember[3]]}
            links={{ 1: "https://www.wowow.co.jp/member/entry.php" }}
          />
          <SectionHeader text={webMember[4]} />
          <InlineText
            texts={[webMember[5], webMember[6]]}
            mt={0}
            target="_blank"
            links={{ 1: "https://www.wowow.co.jp/member/entry.php" }}
          />
          {webMember.slice(7, 14).map((text, index) => (
            <Text key={index} fontSize={{ base: "11px", md: "md", lg: "md" }}>
              {text}
            </Text>
          ))}
          <InlineText
            texts={[webMember[14], webMember[15]]}
            target="_blank"
            links={{
              1: "https://support.wowow.co.jp/answer/61ee1c186ebad800223c3b16",
            }}
          />
          <SectionHeader text={webMember[16]} />
          <Text fontSize={{ base: "11px", md: "md", lg: "md" }}>
            {webMember[17]}
          </Text>
          <InlineText
            texts={[webMember[18], webMember[19]]}
            mt={0}
            target="_blank"
            links={{ 0: "https://www.wowow.co.jp/support/contact/entry.php" }}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default TicketModal;
